import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Reports = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="reports-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.3125 2.6875C3.86275 2.6875 2.6875 3.86275 2.6875 5.3125V18.6875C2.6875 20.1372 3.86275 21.3125 5.3125 21.3125H18.6875C20.1372 21.3125 21.3125 20.1372 21.3125 18.6875V5.3125C21.3125 3.86275 20.1372 2.6875 18.6875 2.6875H5.3125ZM4.4375 5.3125C4.4375 4.82925 4.82925 4.4375 5.3125 4.4375H18.6875C19.1707 4.4375 19.5625 4.82925 19.5625 5.3125V6.11491L15.4676 9.39082C15.2606 9.55636 15.0136 9.66392 14.7521 9.70293C14.7291 9.70476 14.7063 9.70764 14.6839 9.71151C14.4004 9.74061 14.1145 9.68835 13.8596 9.56082L10.8099 8.03598C10.2973 7.77969 9.72197 7.67559 9.15203 7.73602L9.12918 7.73853C9.10461 7.74042 9.08036 7.7435 9.05651 7.7477C8.5218 7.8218 8.01633 8.03894 7.59392 8.37697L4.4375 10.9021V5.3125ZM4.4375 12.9375V12.823L8.43753 9.62302V12.9375H4.4375ZM4.4375 14.4375V16.3125H8.43753V14.4375H4.4375ZM4.4375 17.8125V18.6875C4.4375 19.1707 4.82925 19.5625 5.3125 19.5625H8.43753V17.8125H4.4375ZM9.93753 19.5625H14.0625V17.8125H9.93753V19.5625ZM15.5625 19.5625H18.6875C19.1707 19.5625 19.5625 19.1707 19.5625 18.6875V17.8125H15.5625V19.5625ZM19.5625 16.3125V14.4375H15.5625V16.3125H19.5625ZM19.5625 12.9375V8.03584L16.4045 10.5622C16.1501 10.7657 15.8654 10.9254 15.5625 11.0364V12.9375H19.5625ZM13.1886 10.9024L10.1391 9.37763C10.0738 9.34496 10.0064 9.31723 9.93753 9.29456V12.9375H14.0625V11.1826C13.7601 11.1348 13.4652 11.0407 13.1886 10.9024ZM9.93753 14.4375H14.0625V16.3125H9.93753V14.4375Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
